import { generate } from '@/utils/request';
const config = {
  prefix: '/spur/v1/{organizationId}/',
  items: [
    // 供应商-商品信息列表列表
    { key: 'getSupplierGoodss', url: 'supplier-goodss', method: 'GET' },
    // 创建供应商-商品信息
    { key: 'addSupplierGoodss', url: 'supplier-goodss', method: 'POST' },
    // 修改供应商-商品信息
    { key: 'putSupplierGoodss', url: 'supplier-goodss', method: 'PUT' },
    // 删除供应商-商品信息
    { key: 'deleteSupplierGoodss', url: 'supplier-goodss/batch', method: 'DELETE' },
    // 供应商-商品信息明细
    { key: 'getSupplierGoodssDetail', url: 'supplier-goodss/{id}', method: 'GET' },
    // 供应商商品导出
    { key: 'reportSupplierGoodss', url: 'supplier-goodss/report', method: 'GET', rType: 2 },
  ],
};
export default {
  ...generate(config),
};
